import { drawioEmbedOrigin } from './drawioTypes';

export type DrawioInboundEvent = 'init' | 'save' | 'autosave' | 'export' | 'exit';

export interface DrawioInboundMessage {
  event: DrawioInboundEvent;
  xml?: string;
  data?: string;
  format?: string;
}

export type DrawioOutboundAction = 'load' | 'export' | 'configure';

export interface DrawioOutboundMessage {
  action: DrawioOutboundAction;
  xml?: string;
  format?: string;
  autosave?: number;
}

export function isDrawioSameOriginMessage(event: MessageEvent): boolean {
  if (typeof window === 'undefined') return false;
  return event.origin === window.location.origin;
}

export function parseDrawioMessage(data: unknown): DrawioInboundMessage | null {
  let payload: unknown = data;
  if (typeof data === 'string') {
    try {
      payload = JSON.parse(data);
    } catch {
      return null;
    }
  }
  if (!payload || typeof payload !== 'object') return null;
  const record = payload as Record<string, unknown>;
  if (typeof record.event !== 'string') return null;
  return {
    event: record.event as DrawioInboundEvent,
    xml: typeof record.xml === 'string' ? record.xml : undefined,
    data: typeof record.data === 'string' ? record.data : undefined,
    format: typeof record.format === 'string' ? record.format : undefined
  };
}

export function postDrawioMessage(
  iframe: HTMLIFrameElement | null,
  message: DrawioOutboundMessage
): void {
  if (!iframe?.contentWindow) return;
  iframe.contentWindow.postMessage(JSON.stringify(message), drawioEmbedOrigin());
}

export function postDrawioLoad(iframe: HTMLIFrameElement | null, xml: string, autosave = 1): void {
  postDrawioMessage(iframe, { action: 'load', xml, autosave });
}

export function postDrawioExport(iframe: HTMLIFrameElement | null, format: 'xml' | 'svg' = 'xml'): void {
  postDrawioMessage(iframe, { action: 'export', format });
}
